import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from 'redux'
import { addFlashMessageOfType } from 'redux-flash-messages'
import { withTranslation } from 'react-i18next'

import employeeService from '../../../services/Employee.service'
import { actions as employeeActions } from '../../../actions/employee'

import ReviewAwardDialog from './ReviewAwardDialog'
import AcceptAwardDialog from './AcceptAwardDialog'
import { AwardDialogPage } from './common'

class AcceptAwardWizard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isReviewAwardVisible: true,
      isAcceptAwardVisible: false,
      error: false,
      loading: false
    };
  }

  getPreviousItemFocus = () => {
    document.getElementById(this.props.prevFocusItem)?.focus();
  }

  setReviewAwardVisible = (value) => {
    this.setState({
      isReviewAwardVisible: value
    });
    this.getPreviousItemFocus();
  }

  setAcceptAwardVisible = (value) => {
    this.setState({
      isAcceptAwardVisible: value,
      error: false
    });
    this.getPreviousItemFocus();
  }

  setErrorState = (value) => {
    this.setState({
      error: value
    });
  }

  setLoadingState = (value) => {
    this.setState({
      loading: value
    })
  }

  onAwardNavigationStateChange = (from) => {
    if (from === AwardDialogPage.Review) {
      this.setState({
        isReviewAwardVisible: false,
        isAcceptAwardVisible: true
      });
    } else if (from === AwardDialogPage.Award) {
      this.setState({
        isReviewAwardVisible: true,
        isAcceptAwardVisible: false
      });
    }
  }

  onAcceptAwardAction = () => {
    this.setLoadingState(true);
    this.props.actions.employee.acceptAward(this.props.award.id).then(_ => {
      this.setLoadingState(false);
      this.setAcceptAwardVisible(false);
      addFlashMessageOfType("SUCCESS", false, this.props.t('UnacceptedStockAwards.AcceptedAwardMessage'));
    }).catch(_ => {
      this.setLoadingState(false);
      this.setErrorState(true);
    })
  }

  render() {
    /* 
      since Stencil Flyout in ReviewAwardDialog and AcceptAwardDialog cannot distinguish 
      whether they are closed as a whole (when the user clicks on X button or outside the flyout) or
      they are closed to open up the previous/next flyout, this.props.onWizardClose cannot be triggered
      inside the onCloseDialog() of child dialogs.

      the solution is to check inside render if all child dialogs are closed and if so, close the wizard as whole.

    */
   
    if (!this.state.isReviewAwardVisible && !this.state.isAcceptAwardVisible) {
      this.props.onWizardClose();
      return null;
    }

    const { award } = this.props;

    return (
      <>
        <ReviewAwardDialog
          data-testid="ReviewAwardDialog"
          visible={this.state.isReviewAwardVisible}
          onCloseDialog={() => this.setReviewAwardVisible(false)}
          onButtonPress={() => this.onAwardNavigationStateChange(AwardDialogPage.Review)}
          award={award}
        />
        <AcceptAwardDialog
          data-testid="AcceptAwardDialog"
          visible={this.state.isAcceptAwardVisible}
          onCloseDialog={() => this.setAcceptAwardVisible(false)}
          onButtonPress={() => this.onAcceptAwardAction()}
          onBackButtonPress={() => this.onAwardNavigationStateChange(AwardDialogPage.Award)}
          award={award}
          error={this.state.error}
          dismissError={() => this.setErrorState(false)}
          loading={this.state.loading}
        />
      </>
    );
  }
}

const mapState = state => ({
  unacceptedAwards: employeeService.getUnacceptedRSUs(state.employee.awards),
  locale: state.employee.language
});

const mapDispatchToProps = dispatch => ({
  actions: {
    employee: bindActionCreators(employeeActions, dispatch),
  }
});

export default connect(mapState, mapDispatchToProps)(withTranslation('translationsV2')(AcceptAwardWizard));
